import { ComingSoon } from "components/comingsoon/comingsoon";
import DeleteDialog from "components/dialog/deletedialog";
import RenameDialog from "components/dialog/renamedialog";
import StudioDialog from "components/dialog/studiodialog";
import {
  Animate,
  Card,
  Icon,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  Button,
  CopyStyle,
  useAPI,
  requestServer,
  AuthContext,
  TeamSelector,
} from "components/lib";
import * as SelectPrimitive from "@radix-ui/react-select";
import { useToast } from "components/toast/useToast";
import { useCallback, useEffect, useContext } from "react";
import { useState } from "react";
const accessToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI5YmQzZjJkZi0yOWUwLTQxNDgtOThhMC0wOTQzNDE2ZTkxNmIiLCJzY29wZSI6WyJtYXBzIiwic2VhcmNoIl0sImlhdCI6MTczODU2NzM2OH0.WMfRgaCGg_NSNWY709gTU4mcQ_lFyHylJdR3bmONabQ";

export function Studio({ t }) {
  const [openModal, setOpenModal] = useState(false);
  const [keys, setKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const [openDelModal, setOpenDelModal] = useState(false);
  const [openRenameModal, setOpenRenameModal] = useState(false);
  const [renameTarget, setRenameTarget] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [renameLoading, setRenameLoading] = useState(false);
  const [loadingMaps, setLoadingMaps] = useState({});
  const [deletedId, setDeletedId] = useState(null);
  const [loading, setLoading] = useState(null);
  const [mapList, setMapList] = useState([]);
  const [refetchStylesTrigger, setRefetchStylesTrigger] = useState(0);
  const [userCoords, setUserCoords] = useState([4.9041, 52.3676]); // Amsterdam fallback
  const { toast } = useToast();

  const authContext = useContext(AuthContext);
  const [selectedAccount, setSelectedAccount] = useState(
    authContext.user?.account_id || ""
  );
  const selectedRole =
    authContext.user?.accounts?.find((a) => a.id === selectedAccount)?.permission ||
    authContext.user?.permission;
  const canCreate = selectedRole !== "user";
  const canDelete = selectedRole === "admin" || selectedRole === "owner";

  const stlyeNames = useAPI(
    `/api/studio/styles/get-all?account=${selectedAccount}`,
    "GET",
    refetchStylesTrigger
  );
  const keysResponse = useAPI("/api/key");
  // always call it
  const selectedKeyResp = useAPI(
    selectedKey ? `/api/key/${selectedKey}` : null
  );

  // then later use the token
  const selectedKeyValue = selectedKeyResp?.data?.[0]?.key;

  // init keys
  useEffect(() => {
    if (keysResponse?.data?.length) {
      setKeys(keysResponse.data);
      console.log("keys", keysResponse.data);
    }
  }, [keysResponse]);

  // Fetch user IP geolocation
  useEffect(() => {
    fetch('https://ipinfo.io/json')
      .then(res => res.json())
      .then(data => {
        if (data.loc) {
          const [lat, lng] = data.loc.split(',').map(Number);
          setUserCoords([lng, lat]);
        }
      })
      .catch(err => {
        console.log('IP geolocation failed, using Amsterdam fallback:', err);
      });
  }, []);

  useEffect(() => {
    if (stlyeNames.loading == false && stlyeNames?.data?.files) {
      setMapList(
        stlyeNames?.data?.files.map((fileName) => {
          return {
            id: fileName.split("/")[1],
            image: "/assets/map.png",
            title: fileName.split("/")[1],
            fullName: fileName,
          };
        })
      );
    }
  }, [stlyeNames]);
  useEffect(() => {
    if (!mapList.length) return; // Ensure maps exist before executing

    // Function to initialize maps
    const initializeMaps = () => {
      if (!window.mapmetricsgl) {
        console.error("MapMetrics library not available");
        return;
      }

      mapList.forEach((map) => {
        const mapContainer = document.getElementById(`user-map-${map.id}`);
        if (mapContainer) {
          try {
            const userMap = new window.mapmetricsgl.Map({
              container: `user-map-${map.id}`,
              style: `https://blue-band-4da3.jim9710.workers.dev/styles/?fileName=${map.fullName}&token=${accessToken}`,
              zoom: 8,
              center: userCoords,
              attributionControl: false,
              logo: false,
            });

            userMap.on("load", () => {
              setLoadingMaps((prev) => ({ ...prev, [map.id]: false }));
            });

            userMap.on("error", (error) => {
              console.error(`Error loading map ${map.id}:`, error);
              setLoadingMaps((prev) => ({ ...prev, [map.id]: false }));
            });

            // Disable zooming
            userMap.scrollZoom.disable();
            userMap.doubleClickZoom.disable();
            userMap.touchZoomRotate.disable();

            // Disable dragging (panning)
            userMap.dragPan.disable();
            userMap.dragRotate.disable();

            // Disable keyboard navigation & box zoom
            userMap.keyboard.disable();
            userMap.boxZoom.disable();

            userMap.getCanvas().style.cursor = "auto";
          } catch (error) {
            console.error(`Error initializing map ${map.id}:`, error);
            setLoadingMaps((prev) => ({ ...prev, [map.id]: false }));
          }
        }
      });

      // Load RTL text plugin after main library is loaded
      if (window.mapmetricsgl.setRTLTextPlugin) {
        window.mapmetricsgl.setRTLTextPlugin(
          "https://cdn.mapmetrics-atlas.net/assets/js/mapmetrics-gl-rtl-text.min.js"
        );
      }
    };

    // Set up global initialization callback
    window.onMapMetricsLoaded = function () {
      console.log("MapMetrics loaded via global callback");
      initializeMaps();
    };

    // Load CSS
    const cssLink = document.createElement("link");
    cssLink.rel = "stylesheet";
    cssLink.href =
      "https://cdn.mapmetrics-atlas.net/versions/latest/mapmetrics-gl.css";
    document.head.appendChild(cssLink);

    // Add custom CSS to hide logo
    const customStyle = document.createElement("style");
    customStyle.textContent = `
      .mapmetrics-logo,
      .mapmetricsgl-logo,
      .mapmetrics-gl-logo,
      [class*="logo"] {
        display: none !important;
      }
    `;
    document.head.appendChild(customStyle);

    // Create script element
    const script = document.createElement("script");
    script.src =
      "https://cdn.mapmetrics-atlas.net/versions/latest/mapmetrics-gl.js";
    script.async = false;
    script.defer = false;
    script.onload = () => {
      console.log("MapMetrics script loaded");
      // If the library is already available, initialize immediately
      if (window.mapmetricsgl) {
        console.log("MapMetrics available immediately");
        initializeMaps();
      } else {
        console.log("Waiting for MapMetrics initialization...");
      }
    };
    script.onerror = (error) => {
      console.error("Failed to load MapMetrics library:", error);
      setLoadingMaps((prev) =>
        Object.fromEntries(mapList.map((map) => [map.id, false]))
      );
    };

    // Add the script to the document
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      document.head.removeChild(cssLink);
      if (customStyle.parentNode) {
        customStyle.parentNode.removeChild(customStyle);
      }
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      delete window.onMapMetricsLoaded;
    };
  }, [mapList, userCoords]);

  const openInStudio = useCallback((fullName) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const style = encodeURIComponent(
      `https://blue-band-4da3.jim9710.workers.dev/styles/?fileName=${fullName}&token=${accessToken}`
    );
    window.open("https://studio.mapatlas.net?session=" + user.token + "&style=" + style);
  }, []);
  const openDialog = useCallback(() => {
    setOpenModal(true);
  }, []);
  const openDelDialog = useCallback((id) => {
    setDeletedId(id);
    setOpenDelModal(true);
  }, []);
  const closeDialog = useCallback(() => {
    setOpenModal(false);
  }, []);
  const closeDelDialog = useCallback(() => {
    setOpenDelModal(false);
    setDeletedId(null);
  }, []);
  const openRenameDialog = useCallback((id) => {
    const map = mapList.find((m) => m.id === id);
    setRenameTarget(map || null);
    setRenameValue(map ? map.title.split(".json")[0] : "");
    setOpenRenameModal(true);
  }, [mapList]);
  const closeRenameDialog = useCallback(() => {
    setOpenRenameModal(false);
    setRenameTarget(null);
    setRenameValue("");
  }, []);
  useEffect(
    () => {
      if (openModal || openDelModal || openRenameModal) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }

      // Cleanup function to reset overflow when the component unmounts
      return () => {
        document.body.style.overflow = "";
      };
    },
    [openModal, openDelModal, openRenameModal]
  );
  const handleDuplicate = async (id) => {
    try {
      const selectedMap = mapList.find((map) => map.id === id);

      if (!selectedMap) {
        console.error("Selected map not found!");
        return;
      }

      // Fetch the actual style JSON from the gateway
      const styleJsonResponse = await fetch(
        `https://blue-band-4da3.jim9710.workers.dev/styles/?fileName=${selectedMap.fullName}&token=${accessToken}`
      );

      if (!styleJsonResponse.ok) {
        console.error("Failed to fetch style JSON");
        return;
      }

      const actualStyleData = await styleJsonResponse.json();

      const newStyleName = `${selectedMap.title.split(".json")?.[0]}-copy`;
      const payload = {
        styleName: newStyleName,
        styleData: actualStyleData,
        account: selectedAccount,
      };

      const response = await requestServer(
        "/api/studio/styles/create",
        "POST",
        payload
      );

      if (response?.success) {
        // refetch the full list from the server so the new map renders
        // with a real id/fullName (same pattern as handleDelete)
        setRefetchStylesTrigger((prev) => prev + 1);
      } else {
        console.error(
          "Failed to duplicate style:",
          response?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error duplicating style:", error);
    }
  };
  const handleDelete = useCallback(async () => {
    setLoading(true);
    const response = await requestServer(
      "/api/studio/styles/delete",
      "DELETE",
      { styleName: deletedId, account: selectedAccount }
    );
    if (response.success) {
      setRefetchStylesTrigger(refetchStylesTrigger + 1);
    }
    setLoading(false);
    closeDelDialog();
  }, [deletedId, closeDelDialog, selectedAccount, refetchStylesTrigger]);

  // Rename = create the style under a new name (re-authorizes keys), then
  // delete the original, then reload the list from the backend. Reuses the
  // same endpoints as duplicate + delete (no dedicated rename endpoint).
  const handleRename = useCallback(async () => {
    const map = renameTarget;
    const newName = renameValue.trim().replace(/\.json$/i, "");
    if (!map || !newName) return;

    // no-op if the name didn't change
    if (`${newName}.json` === map.id || newName === map.id) {
      closeRenameDialog();
      return;
    }

    setRenameLoading(true);
    try {
      // fetch the current style JSON from the gateway
      const styleJsonResponse = await fetch(
        `https://blue-band-4da3.jim9710.workers.dev/styles/?fileName=${map.fullName}&token=${accessToken}`
      );
      if (!styleJsonResponse.ok) {
        toast({ title: "Rename failed", description: "Could not load the map style.", variant: "destructive" });
        return;
      }
      const styleData = await styleJsonResponse.json();

      // create under the new name
      const createRes = await requestServer("/api/studio/styles/create", "POST", {
        styleName: newName,
        styleData,
        account: selectedAccount,
      });
      if (!createRes?.success) {
        toast({ title: "Rename failed", description: createRes?.message || "Could not create the renamed map.", variant: "destructive" });
        return;
      }

      // delete the original
      await requestServer("/api/studio/styles/delete", "DELETE", {
        styleName: map.id,
        account: selectedAccount,
      });

      // reload the list from the backend
      setRefetchStylesTrigger((prev) => prev + 1);
      closeRenameDialog();
    } catch (error) {
      console.error("Error renaming style:", error);
      toast({ title: "Rename failed", description: "Something went wrong.", variant: "destructive" });
    } finally {
      setRenameLoading(false);
    }
  }, [renameTarget, renameValue, selectedAccount, closeRenameDialog, toast]);

  const actions = [
    {
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.1665 0.666626H4.83317C5.29341 0.666626 5.6665 1.03972 5.6665 1.49996C5.6665 1.92732 5.3448 2.27955 4.93035 2.32769L4.83317 2.33329H3.1665C2.73914 2.33329 2.38691 2.65499 2.33878 3.06944L2.33317 3.16663V14.8333C2.33317 15.2607 2.65487 15.6129 3.06932 15.661L3.1665 15.6666H14.8332C15.2605 15.6666 15.6128 15.3449 15.6609 14.9305L15.6665 14.8333V13.1666C15.6665 12.7064 16.0396 12.3333 16.4998 12.3333C16.9272 12.3333 17.2794 12.655 17.3276 13.0694L17.3332 13.1666V14.8333C17.3332 16.1647 16.2924 17.253 14.9801 17.329L14.8332 17.3333H3.1665C1.8351 17.3333 0.746786 16.2925 0.670748 14.9802L0.666504 14.8333V3.16663C0.666504 1.83523 1.70727 0.746909 3.01961 0.67087L3.1665 0.666626ZM16.4998 0.666626L16.5673 0.669126L16.6671 0.683493L16.76 0.708074L16.8525 0.744687L16.9338 0.788289L17.0138 0.843948L17.0891 0.910704L17.1696 1.00387L17.2293 1.09657L17.2551 1.14738L17.2833 1.21525L17.3033 1.2783L17.3274 1.40155L17.3332 1.49996V6.49996C17.3332 6.9602 16.9601 7.33329 16.4998 7.33329C16.0396 7.33329 15.6665 6.9602 15.6665 6.49996V3.51163L10.4224 8.75588C10.122 9.05628 9.64933 9.07939 9.32242 8.82521L9.24391 8.75588C8.94351 8.45548 8.9204 7.98279 9.17459 7.65588L9.24391 7.57737L14.4865 2.33329H11.4998C11.0396 2.33329 10.6665 1.9602 10.6665 1.49996C10.6665 1.03972 11.0396 0.666626 11.4998 0.666626H16.4998Z"
            fill="currentColor"
          />
        </svg>
      ),
      label: t("global.table.action.open"),
      action: (fullName) => openInStudio(fullName),
    },
    // {
    //   icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3844 12.3077C14.0229 12.3077 12.8344 13.0192 12.1506 14.0862L8.03136 11.7323C8.29751 11.2092 8.46135 10.6262 8.46135 10C8.46135 9.61308 8.38675 9.24691 8.28059 8.89461L12.566 6.44616C13.2683 7.2077 14.2667 7.69231 15.3844 7.69231C17.509 7.69231 19.2306 5.97077 19.2306 3.84615C19.2306 1.72154 17.509 0 15.3844 0C13.2598 0 11.5383 1.72154 11.5383 3.84615C11.5383 4.23308 11.6129 4.59922 11.719 4.9523L7.43366 7.4C6.73135 6.63923 5.73289 6.15385 4.6152 6.15385C2.49058 6.15385 0.769043 7.87538 0.769043 10C0.769043 12.1246 2.49058 13.8462 4.6152 13.8462C5.49212 13.8462 6.29134 13.5415 6.93827 13.0477L11.5806 15.7385C11.5652 15.8769 11.5383 16.0108 11.5383 16.1538C11.5383 18.2785 13.2598 20 15.3844 20C17.509 20 19.2306 18.2785 19.2306 16.1538C19.2306 14.0292 17.509 12.3077 15.3844 12.3077Z" fill="#45464E"/>
    //   </svg>,
    //   label: t("global.table.action.share"),
    //   action: () => openDialog(),
    // },
    canCreate && {
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.5 0H7.5C6.11937 0 5 1.11937 5 2.5V12.5C5 13.8806 6.11937 15 7.5 15H17.5C18.8806 15 20 13.8806 20 12.5V2.5C20 1.11937 18.8806 0 17.5 0ZM3.75 13.125V5H2.5C1.11937 5 0 6.11937 0 7.5V17.5C0 18.8806 1.11937 20 2.5 20H12.5C13.8806 20 15 18.8806 15 17.5V16.25H6.875C5.49437 16.25 3.75 14.5056 3.75 13.125Z"
            fill="currentColor"
          />
        </svg>
      ),
      label: t("global.table.action.duplicate"),
      action: (fullName) => handleDuplicate(fullName.split("/")[1]),
    },
    canDelete && {
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 20h4l10.5-10.5a2.121 2.121 0 0 0-3-3L5 17v3z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      label: t("global.table.action.rename"),
      action: (fullName) => openRenameDialog(fullName.split("/")[1]),
    },
    canDelete && {
      icon: (
        <svg
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.291504 4.13897C0.291504 3.75545 0.579321 3.44454 0.934362 3.44454L3.15456 3.44416C3.59569 3.43209 3.98485 3.1291 4.13495 2.68084C4.1389 2.66906 4.14344 2.65452 4.15971 2.60177L4.25538 2.29169C4.31392 2.10157 4.36492 1.93594 4.4363 1.78788C4.71825 1.20299 5.2399 0.796832 5.84273 0.692849C5.99531 0.666524 6.1569 0.66664 6.34242 0.666765H9.24075C9.42625 0.66664 9.58784 0.666524 9.74042 0.692849C10.3433 0.796832 10.8649 1.20299 11.1468 1.78788C11.2183 1.93594 11.2693 2.10157 11.3278 2.29169L11.4234 2.60177C11.4398 2.65452 11.4443 2.66906 11.4482 2.68084C11.5983 3.1291 12.0647 3.43247 12.5058 3.44454H14.6487C15.0037 3.44454 15.2915 3.75545 15.2915 4.13897C15.2915 4.52251 15.0037 4.83342 14.6487 4.83342H0.934362C0.579321 4.83342 0.291504 4.52251 0.291504 4.13897Z"
            fill="#E00101"
          />
          <path
            d="M7.6725 17.3332H8.32825C10.5845 17.3332 11.7126 17.3333 12.4461 16.6139C13.1796 15.8946 13.2547 14.7147 13.4047 12.3548L13.621 8.95425C13.7024 7.67383 13.7432 7.03358 13.3752 6.62788C13.0072 6.22217 12.3858 6.22217 11.143 6.22217H4.85771C3.61492 6.22217 2.99353 6.22217 2.62556 6.62788C2.25759 7.03358 2.29831 7.67383 2.37974 8.95425L2.596 12.3548C2.74608 14.7147 2.82112 15.8946 3.55462 16.6139C4.28811 17.3333 5.41622 17.3332 7.6725 17.3332Z"
            fill="#E00101"
          />
        </svg>
      ),
      label: t("global.table.action.delete"),
      // action: deleteKey,
      global: true,
      color: "#E00101",
      action: (fullName) => openDelDialog(fullName.split("/")[1]),
    },
  ].filter(Boolean);
  // Prevent horizontal scroll on mount
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = 'auto';
      document.documentElement.style.overflowX = 'auto';
    };
  }, []);

  return (
        <Animate type="pop" className="space-y-4 w-full">
          <TeamSelector value={selectedAccount} onChange={setSelectedAccount} />
          <div className="flex flex-col xl:flex-row gap-3 min-h-[650px] w-full overflow-x-hidden">
            <div className="xl:flex-[0.7] min-w-0 overflow-x-hidden">
              <Card title={t("studio.map_desing.title")} className="p-3 ml-4">
            <ul className="mt-2 space-y-5">
              {mapList.length > 0 ? (
                <>
                  {mapList.map((map, i) => {
                    console.log(map, "map");
                    return (
                      <li className="flex items-center" key={i}>
                        <div className="image w-[104px] h-[130px] xl:w-[130px] xl:h-[120px] rounded-xl bg-gray-300/10 glass-card dark:glass-card-dark overflow-hidden flex-none relative">
                          {loadingMaps[map.id] != false && (
                            <div className="absolute inset-0 flex items-center justify-center bg-white/5 backdrop-blur-sm rounded-xl opacity-75">
                              <div className="animate-spin rounded-full h-10 w-10 border-4 border-white/30 border-t-transparent"></div>
                            </div>
                          )}
                          <div
                            id={`user-map-${map.id}`}
                            className="w-full h-full"
                          ></div>
                        </div>
                        <div className="flex justify-between w-full flex-grow">
                          <div className="ml-5">
                            <h3 className="text-white/90 text-xl font-light leading-normal tracking-wide mb-2 poppins-light">
                              {map.title}
                            </h3>
                          </div>
                          <DropdownMenu>
                            <DropdownMenuTrigger className="focus:outline-none">
                              <div className="relative top-[2px] [&_span]:sr-only">
                                <span>Open menu</span>
                                <Icon name="more-vertical" />
                              </div>
                            </DropdownMenuTrigger>

                            <DropdownMenuContent
                              align="end"
                              className="w-[280px] rounded-2xl glass-card dark:glass-card-dark border border-white/10 p-4 shadow-xl space-y-3 poppins-light backdrop-blur-lg"
                            >
                              {actions
                                .filter((a) => !a.globalOnly)
                                .map((action, index) => {
                                  const isDelete =
                                    (action.label || "").toLowerCase() ===
                                    "delete";

                                  const Action = (
                                    <DropdownMenuItem
                                      className="cursor-pointer rounded-xl hover:bg-white/10 transition-all duration-300 px-3 py-2"
                                      key={index}
                                      onClick={() =>
                                        action.action(map.fullName)
                                      }
                                    >
                                      <div
                                        className={`flex flex-row ${
                                          isDelete
                                            ? "text-red-400"
                                            : "text-white/90"
                                        }`}
                                      >
                                        <div className="pr-2">
                                          {action.icon}
                                        </div>
                                        <Button
                                          size="full"
                                          variant="naked"
                                          text={action.label}
                                          className={`justify-start`}
                                        />
                                      </div>
                                    </DropdownMenuItem>
                                  );

                                  if (!action.condition) return Action;

                                  const ctx = map || {};
                                  const matchesCondition = Object.entries(
                                    action.condition
                                  ).every(
                                    ([key, val]) => ctx && ctx[key] === val
                                  );

                                  return matchesCondition ? Action : null;
                                })}

                              {/* Connect API key with style */}
                              <div className="px-1 pt-1">
                                <span className="mb-2 font-semibold block text-[12px] leading-[16px] text-white/80 poppins-medium">
                                  Connect API key with style
                                </span>

                                <SelectPrimitive.Root
                                  defaultValue=""
                                  onValueChange={(value) => setSelectedKey(value)}
                                >
                                  <SelectPrimitive.Trigger className="h-10 w-full appearance-none rounded-xl glass-input px-3 pr-8 text-sm text-white/90 outline-none border-white/10 focus:border-blue-400/50 focus:bg-white/10 transition-all duration-300 flex items-center justify-between">
                                    <SelectPrimitive.Value placeholder="Connect key" />
                                    <SelectPrimitive.Icon asChild>
                                      <Icon name="chevron-down" className="h-4 w-4 opacity-70 text-white" />
                                    </SelectPrimitive.Icon>
                                  </SelectPrimitive.Trigger>

                                  <SelectPrimitive.Portal>
                                    <SelectPrimitive.Content className="relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-xl border border-white/20 bg-white/10 backdrop-blur-xl text-white shadow-lg shadow-black/20 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95" position="popper">
                                      <SelectPrimitive.Viewport
                                        className="p-1 max-h-60 overflow-y-scroll glass-scrollbar"
                                        style={{
                                          scrollbarWidth: 'thin',
                                          scrollbarColor: 'rgba(255, 255, 255, 0.5) rgba(255, 255, 255, 0.1)',
                                        }}
                                      >
                                        {keys.map((k) => (
                                          <SelectPrimitive.Item
                                            key={k.id}
                                            value={k.id}
                                            className="relative flex w-full cursor-pointer select-none items-center rounded-lg py-2 pl-8 pr-2 text-white outline-none hover:bg-white/10 focus:bg-white/10 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 transition-colors"
                                          >
                                            <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
                                              <SelectPrimitive.ItemIndicator>
                                                <Icon name="check" className="h-4 w-4 text-white" />
                                              </SelectPrimitive.ItemIndicator>
                                            </span>
                                            <SelectPrimitive.ItemText>{k.name}</SelectPrimitive.ItemText>
                                          </SelectPrimitive.Item>
                                        ))}
                                      </SelectPrimitive.Viewport>
                                    </SelectPrimitive.Content>
                                  </SelectPrimitive.Portal>
                                </SelectPrimitive.Root>
                              </div>
                              {/* Copy your style URL */}
                              <div className="px-1">
                                <span className="mb-2 font-semibold block text-[12px] leading-[16px] text-white/80 poppins-medium">
                                  Copy your style URL
                                </span>
                                <div className="relative flex flex-row">
                                  <input
                                    readOnly
                                    value={
                                      selectedKey
                                        ? selectedKeyResp.loading
                                          ? "Revealing key.."
                                          : `https://gateway.mapmetrics-atlas.net/styles/?fileName=${map.fullName}&token=${selectedKeyValue}`
                                        : "Select a key first"
                                    }
                                    className="h-10 w-full rounded-xl glass-input px-3 pr-10 text-sm text-white/70 outline-none border-white/10"
                                  />
                                  {selectedKeyResp.loading == false ? (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        if (selectedKey && !selectedKeyResp.loading) {
                                          navigator.clipboard.writeText(
                                            `https://gateway.mapmetrics-atlas.net/styles/?fileName=${map.fullName}&token=${selectedKeyValue}`
                                          );
                                          toast({
                                            title: "Key copied",
                                            description: "Your selected key has been copied to your clipboard"
                                          });
                                        }
                                      }
                                    }
                                      className={`place-items-center rounded-xl p-1.5 ${selectedKey ? 'glass-button hover:glass-button-hover' : "bg-white/10 hover:bg-white/15"} text-white shadow-md transition-all duration-300`}
                                      aria-label="Copy style URL"
                                      title="Copy"
                                    >
                                      <Icon name="copy"/>
                                    </button>
                                  ) : (
                                    <>
                                      <Icon
                                        name="loader"
                                        size={38}
                                        className="animate-spin"
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </div>
                      </li>
                    );
                  })}
                </>
              ) : (
                <p className="text-white/80 text-[16px] leading-[24px] text-center mb-12 poppins-light">
                  There is no map design. To create new design please click on{" "}
                  <b>Start Design</b> button
                </p>
              )}
              </ul>
              </Card>
            </div>
            <div className="xl:flex-[0.3] xl:flex-shrink-0 flex flex-col gap-3">
              <ComingSoon t={t} />
              <Card title={t("studio.studio_guide.title")} className="p-3">
            <div className="mt-4">
              <div className="flex gap-4 items-center">
                <Icon name="newspaper" className="text-white/70" />
                <a
                  href="https://docs.mapatlas.xyz/"
                  className="text-blue-300 text-[16px] cursor-pointer hover:text-blue-200 transition-colors duration-300 poppins-light"
                  target="_blank"
                >
                  API and Plugin menu
                </a>
              </div>
                </div>
              </Card>
              <StudioDialog closeDialog={closeDialog} openModal={openModal} />
              {openDelModal && (
                <DeleteDialog
                  closeDialog={closeDelDialog}
                  action={handleDelete}
                  loading={loading}
                />
              )}
              {openRenameModal && (
                <RenameDialog
                  closeDialog={closeRenameDialog}
                  action={handleRename}
                  loading={renameLoading}
                  value={renameValue}
                  onChange={setRenameValue}
                  currentName={renameTarget?.title}
                />
              )}
        </div>
          </div>
        </Animate>
  );
}
